import { render, staticRenderFns } from "./IndustriesTable.vue?vue&type=template&id=1228d7cf&"
import script from "./IndustriesTable.vue?vue&type=script&lang=js&"
export * from "./IndustriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports